import { defineStyleConfig } from '@chakra-ui/react'

export const textareaTheme = defineStyleConfig({
  baseStyle: {
    display: 'block',
    fontSize: '12px',
    paddingX: '8px',
    paddingY: '8px',
    height: 'auto',
    minHeight: 'auto',
    lineHeight: '14.63px',
    fontWeight: '500',
    color: 'presets.turquoise.100',
    border: '1px solid',
    borderColor: 'presets.neutral.30',
    borderRadius: '6px',
    backgroundColor: 'presets.neutral.0',
    boxSizing: 'border-box',
    _dark: {
      backgroundColor: 'rgba(255, 255, 255, 0.3)',
      borderColor: 'transparent',
      color: 'white',
    },
    _focus: {
      borderColor: 'presets.turquoise.70 !important',
      boxShadow: 'none',
      _dark: {
        borderColor: 'presets.turquoise.50 !important',
        //Needed to add this here for some reason.
        color: 'white',
        backgroundColor: 'rgba(255, 255, 255, 0.3)',
      },
    },
    _hover: {
      borderColor: 'presets.turquoise.50',
    },
    _placeholder: {
      color: 'presets.neutral.60',
      _dark: {
        color: 'white',
      },
    },
  },
  variants: {
    outline: {
      border: '1px solid',
      borderColor: 'presets.neutral.30',
      _focus: {
        borderColor: 'presets.turquoise.70 !important',
        boxShadow: 'none',
      },
      _hover: {
        borderColor: 'presets.turquoise.50',
      },
    },
  },
  defaultProps: {
    variant: 'outline',
  },
})
